import React from 'react';
import { InputAdornment, TextField } from '@material-ui/core';
import { FieldProps } from 'formik';

interface IProps extends FieldProps {
  placeholder: string;
  label: string;
  disabled?: boolean;
  error?: boolean;
  multiline?: boolean;
  iconType?: string;
  type?: string;
  helperText?: string;
}

export const JwlField: React.FC<IProps> = ({
  placeholder,
  label,
  field,
  disabled,
  error = false,
  multiline = false,
  iconType = null,
  helperText = '',
  type = 'text'
}) => {
  return (
    <TextField
      size="small"
      variant="outlined"
      placeholder={placeholder}
      type={type}
      label={label}
      disabled={disabled}
      error={error}
      multiline={multiline}
      helperText={helperText}
      rows={multiline ? 3 : 1}
      InputProps={{
        startAdornment: iconType ? <InputAdornment position="start">{iconType}</InputAdornment> : ''
      }}
      {...field}
      style={{
        marginTop: '12px',
        marginBottom: '4px',
        width: '100%'
      }}
    />
  );
};
